import React from "react";
import { ptList } from "../../../lib/playTypes";

// Isolation · "Why are they in isolation?" — one pick (ISO-W1/W2/W3) saved on the record, required before the plan shows.
// ISO-W3 suggests the Ball stopper tag (coach confirms it in panel 3).
export function PlayTypeWhy({ cfg, lib, pt, readOnly, onChange }) {
  const W = cfg.why;
  const opts = ptList(lib, W.list);
  const pick = (id) => onChange(s => {
    const why = s.why === id ? null : id;
    const tags = [...(s.outcome_tags || [])];
    const sug = W.suggestTag?.[why];
    if (sug && !tags.some(t => t.id === sug)) tags.push({ id: sug, most_seen: false, suggested: true });
    return { ...s, why, outcome_tags: why ? tags : tags.filter(t => !t.suggested) };
  });
  const note = pt.why && W.notes?.[pt.why];
  return (
    <div className={`border p-4 space-y-3 bg-[#141414] ${pt.why ? "border-white/10" : "border-[#f59e0b]/60"}`} data-testid="pt-why">
      <div className="flex items-center gap-3 flex-wrap"><span className="text-[9px] font-mono text-[var(--org-accent)]">1b</span><div className="text-[10px] uppercase tracking-[0.35em] font-bold text-white">{W.title}</div><div className={`text-[10px] ${pt.why ? "text-[#757575]" : "text-[#f59e0b]"}`}>{W.hint}</div></div>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-2">
        {opts.map(o => { const on = pt.why === o.id; return (
          <button key={o.id} type="button" disabled={readOnly} onClick={() => pick(o.id)} title={o.links}
            className={`text-left border p-3 transition-colors ${on ? "border-[var(--org-accent)] bg-[var(--org-accent)]/10" : "border-white/15 hover:border-white/40"} disabled:opacity-60`} data-testid={`pt-why-${o.id}`}>
            <div className={`text-[11px] font-semibold ${on ? "text-white" : "text-[#e0e0e0]"}`}>{o.name}</div>
            <div className="text-[10px] text-[#8a8a8a] mt-0.5">{o.detail}</div>
            <div className="text-[9px] text-[#757575] mt-1.5">{o.links}</div>
          </button>); })}
      </div>
      {note && <div className="border-l-2 border-[#f59e0b] pl-3 text-[11px] text-[#f5d58b]" data-testid={`pt-why-note-${pt.why}`}>{note}</div>}
    </div>
  );
}
